import { render, staticRenderFns } from "./BulkApproveLocalDialog.vue?vue&type=template&id=11f08ca4"
import script from "./BulkApproveLocalDialog.vue?vue&type=script&lang=js"
export * from "./BulkApproveLocalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports